<template>
  <b-container class=" mt-2 mt-lg-5 mb-5 p-0">
    <b-row class=" justify-content-center no-gutters">
      <b-col class="col-12 mt-5">
        <b-card class="rounded-sm bg-light"  header-tag="header">
          <template #header>
            <recipe-header 
              :recipe="recipe" 
              :editable="editable" 
              :kCalTotal="kCalTotal"
              @toggle-edit-mode="toggleEditMode"
              @update-recipe="submitRecipeTimeout" 
            />
          </template>
          <b-card-body class="card-body py-2 px-0 ">
            <b-container >
              <b-row  >
                <b-col class="col-9 col-md-6 px-0 ml-0 mr-0 " >
                  <b-row class="border-0">
                    <servings-counter 
                      :servings="numberOfEaters" 
                      :editable="editable"
                      @change-servings="handleServingsChange"
                    />
                  </b-row>
                </b-col>
                <b-col cols="auto" class="ml-auto d-block d-lg-none px-0 border-0" >
                  <b-button  :variant="editable ? 'secondary' : 'primary'"
                    title="Receptgegevens aanpassen" :pressed="false"
                    @click="editable = !editable, draggableList = false" >
                      <b-icon class="mr-1" :icon="editable? 'pencil-fill': 'pencil-fill'" :variant="editable? 'dark' : 'default'"/>{{!editable ? 'Edit' : 'Klaar'}}</b-button >
                </b-col>
              </b-row>
            </b-container>
          </b-card-body>
          <b-container >
            <b-row >
              <b-col class=" px-0 col-12 ">
                <b-row >
                  <b-col class="col-12 col-lg-6" order-lg="2">
                    <recipe-image-uploader
                      :image-url="imageURL"
                      :editable="editable"
                      :alt-text="recipe.naam"
                      @image-uploaded="uploadURL = $event"
                    />
                  </b-col>
                  <b-col order-lg="1">
                    <recipe-ingredients-list
                      :ingredients="recipeIngredients"
                      :editable="editable"
                      :draggable-list="draggableList"
                      :all-selected="allSelected"
                      :drag="drag"
                      @toggle-list-mode="toggleListModus"
                      @create-ingredient="createIngredient"
                      @toggle-selected="toggleSelected"
                      @show-ingredient-modal="showIngredientModal"
                      @drag-start="drag = true"
                      @save-ingredients="saveIngredients"
                      @drag-end="drag = false"
                      @update-ingredients="updateIngredientsOrder"
                    >
                      <template #shopping-list-buttons>
                        <shopping-list-add-button
                          :selected-count="selectedRecpIngrCount"
                          :editable="editable"
                          @add-to-shopping-list="addRecipeToShoppingList(recipe)"
                        />
                      </template>
                    </recipe-ingredients-list>
                  </b-col>
                </b-row>
                <recipe-description
                  :recipe="recipe"
                  :editable="editable"
                  @update-recipe="submitRecipeTimeout"
                  @show-description-modal="$bvModal.show('modalRecipeDescription')"
                  @submit-recipe="submitRecipe"
                />
                
                <recipe-tags
                  v-if="roles && roles.includes('admin') && editable"
                  :selected-tags="selectedTags"
                  :is-admin="roles && roles.includes('admin')"
                  :editable="editable"
                  :available-tags="tags"
                  @update-tags="saveSelectedTags"
                />
                
                <delete-recipe-button
                  :recipe-name="recipe.naam"
                  :editable="editable"
                  @delete-recipe="deleteRecipe"
                />
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </b-col>
    </b-row>

    <modal-recipe-ingredient 
      :userID="activeUserID"
      :recipeID="recipeID"
      :recipe="recipe"
      :selectedIngredient="selectedIngredient"
      :ingredients="ingredients"
      :operations="operations"
      :categories="categories"
      :nevoIngredients="nevoIngredients"
      :units="units"
      :eaters="this.numberOfEaters"
      @createIngredient="submitCreatedIngredient"
      @updateIngredient="submitUpdatedIngredient"
      @deleteIngredient="submitDeleteIngredient"/>

    <modal-recipe-description
      :userID="userID" 
      :recipe="recipe" 
      @submitRecipe="submitRecipe"/>



  </b-container>
</template>
<script>
import db from "../db.js";
import ModalRecipeIngredient from "../components/ModalRecipeIngredient"
import ModalRecipeDescription from "../components/ModalRecipeDescription"
import RecipeHeader from "../components/RecipeHeader"
import ServingsCounter from "../components/ServingsCounter"
import RecipeIngredientsList from "../components/RecipeIngredientsList"
import RecipeDescription from "../components/RecipeDescription"
import RecipeTags from "../components/RecipeTags"
import RecipeImageUploader from "../components/RecipeImageUploader"
import DeleteRecipeButton from "../components/DeleteRecipeButton"
import ShoppingListAddButton from "../components/ShoppingListAddButton"
// draggable wordt nu alleen gebruikt in RecipeIngredientsList component
import firebase from "firebase"
const EMPTY_INGREDIENT = {calculatedNumber:1, aantal: 1, eenheid: {}, ingredient: {}, bewerking: {}}
export default {
  name: "recipe-detail",
  data: function() {
    return {
      recipe: {
        naam: "",
        aantal_personen: 4
      },
      recipeModalTabIndex: 0,
      selectedIngredient: EMPTY_INGREDIENT,
      numberOfPersons: 4,
      numberOfEaters: 4,
      eaterPersonRatio: 1,
      recipeIngredients: [],
      recipeID: this.$route.params.recipeID,
      ingrNumberInput: null,
      cancelSubmitRecipeTimeout: null,
      drag: false,
      draggableList: false,
      unsubscribe: null,
      selectedTags: [],
      tagIDs: [],
      tagsDirty: false,
      tagsAllFound: null,
      validateTags: false,
      tagError: "",
      uploadURL: null,
      imageURL: null,
      editable: null,
      shoppingList: [],
      shoppingListRecipes: [],
      headerHeight: 20,
      kCalTotal: 0
    };
  },
  props: ["user", "userID", "activeUserID", "units", "ingredients", "operations", "categories", "tags", "roles", "nevoIngredients"],
  components: {
    ModalRecipeIngredient,
    ModalRecipeDescription,
    RecipeHeader,
    ServingsCounter,
    RecipeIngredientsList,
    RecipeDescription,
    RecipeTags,
    RecipeImageUploader,
    DeleteRecipeButton,
    ShoppingListAddButton
  },
  watch: {
    selectedTags(newTags) {
      if(!this.validateTags) return;
      this.tagsDirty = newTags.length == 0 ? false : true ;
      this.tagIDs = []
      this.tagsAllFound = true
      this.tagError = "Niet gevonden tag(s): "
      for (let i = 0; i < newTags.length; i++) {
        const newTag = newTags[i];
        var found = false
        for (let j = 0; j < this.tags.length; j++) {
          const tag = this.tags[j];
          if(newTag.toLowerCase() == tag.text.toLowerCase()) {
            found = true
            break
          }
        }
        if(!found) {
          this.tagError = this.tagError + newTag + " "
          this.tagsAllFound = false
        }
      }
      if(this.tagsAllFound) {
        this.saveSelectedTags(this.selectedTags)
      }
    },
    uploadURL(value) {
      if(value) {
        try {
          console.log(value)
          const imageName = this.getImageName(this.recipe.naam, this.activeUserID, this.recipeID);
          const imageRef = this.getImageRef(imageName);
          console.log(imageRef.fullPath)
          console.log("For uploading implement rules to prevent abuse: https://firebase.google.com/docs/storage/security")
          //For uploading implement rules to prevent abuse: https://firebase.google.com/docs/storage/security
          imageRef.put(value).then( snapshot => {
            console.log("uploaded!", snapshot)
            const recipeRef = db.collection("users").doc(this.activeUserID).collection("recipes").doc(this.recipeID)
            recipeRef.update({image: imageName}).then( ()=> {
              this.loadImage(imageRef)
            })
            .catch((error) => {
              console.log(error.message)
            })
            
          })
          .catch( error => {
            console.log("File put error: " + error)
          })
        }
        catch(error) {
          console.log("Storage Error: " + error)
        }
      }
    }
  },
  computed: {
    state() {
        // Overall component validation state Can be true, false or null
        // this.tagsDirty ? this.selectedTags.length > 0  : null
        return this.tagsDirty ? this.selectedTags.length > 0 && this.tagsAllFound : null
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    selectedRecpIngrCount() {
      var count = 0
      if(this.recipeIngredients) {
        for (let i = 0; i < this.recipeIngredients.length; i++) {
          const ingr = this.recipeIngredients[i];
          count += (ingr.selected ? 1 : 0)
        }
      }
      return count
    },
    allSelected: function() {
      let selectCount = 0
      for (let i = 0; i < this.recipeIngredients.length; i++) {
        const rcpIngr = this.recipeIngredients[i];
        if(rcpIngr.selected) {
          selectCount++
        }
      }
      return selectCount == this.recipeIngredients.length
    }
  },
  methods: {
    toggleEditMode: function() {
      this.editable = !this.editable;
      this.draggableList = false;
    },
    handleServingsChange: function(value) {
      if (this.editable) {
        this.changeRecipeRatio(value);
      } else {
        this.calcEaterChange(value);
      }
    },
    toggleSelected: function() {
      if(this.allSelected) {
        this.selectNothing()
      } else {
        this.selectAll()
      }
    },
    selectAll: function() {
      for (let i = 0; i < this.recipeIngredients.length; i++) {
        const rcp = this.recipeIngredients[i];
        rcp.selected = true;
      }
    },
    selectNothing: function() {
      for (let i = 0; i < this.recipeIngredients.length; i++) {
        const rcp = this.recipeIngredients[i];
        rcp.selected = false;
      }
    },
    /**
     * 1) Loops through this ingredients
     * 2) Multiplies aantal with the eaterPersonRatio
     * 3) Loops through the shoppingList to match ingredient and unit.
     * 4) If found adds up aantal of units, if not found adds ingredient to the shoppingList
     * 
     * param {*} recipe 
     * for recipe[ingredients] => i
     *   i.aantal = r.eaterPersonRatio * i.aantal
     *   for [this.shoppingList] => sli
     *     if(i.ingredient == sli.ingredient && i.eenheid == sli.eenheid)
     *       sli.aantal += i.aantal
     *       found = true
     *   if(!found)
     *     this.shoppingList.push(clone(i))
     */
    addRecipeToShoppingList: function(recipe) {
      const rcp = Object.assign({},recipe);
      rcp.id = this.recipeID;
      rcp.recipeInstanceID = Date.now().toString(36);
      this.shoppingListRecipes.push(rcp)
      if (!recipe.eaterPersonRatio) {
        recipe.eaterPersonRatio = 1;
      }
      for (let j = 0; j < recipe.ingredients.length; j++) {
        if(!this.recipeIngredients[j].selected){ continue }
        const rcpItem = Object.assign({},recipe.ingredients[j]);
        rcpItem.aantal *= recipe.eaterPersonRatio;
        var found = false;
        for (let i = 0; i < this.shoppingList.length; i++) {
          const shpLstItem = this.shoppingList[i];
          if ( rcpItem.ingredient.id == shpLstItem.ingredient.id &&
            rcpItem.eenheid.id == shpLstItem.eenheid.id ) {
            found = true;
            shpLstItem.aantal += rcpItem.aantal;
            shpLstItem.selected = false;
            shpLstItem.recipeIDs.push({recipeInstanceID: rcp.recipeInstanceID, aantal: rcpItem.aantal})
          }
        }
        if (!found) { 
          rcpItem.recipeIDs = [{recipeInstanceID: rcp.recipeInstanceID, aantal: rcpItem.aantal}]
          rcpItem.selected = false;
          this.shoppingList.push( rcpItem);
        }
      }
      const shoppingListRef = db.collection('users').doc(this.activeUserID).collection('shoppingLists').doc("active")
      shoppingListRef.update({items: this.shoppingList, recipes: this.shoppingListRecipes}).then(()=> {
        const toastObj = {
            title: `${recipe.naam} toegevoegd`,
            toaster: 'b-toaster-bottom-left',
            variant: 'warning',
            solid: true,
            appendToast: false
          }
        this.$emit("showToast",["'" + recipe.naam + "' toegevoegd aan boodschappenlijstje",toastObj] )
        this.pushRouterTarget('/shopping-list')
      })
    },
    pushRouterTarget: function(target) {
      if (this.$route.path != target){
        this.$router.push(target);
      }
    },
    tagValidator(tag) {
      // Individual tag validator function. Check all lowercase chars tag === tag.toLowerCase() &&
      return tag === tag.toLowerCase() && tag.length > 0 && tag.length <= 100
    },
    saveSelectedTags: function(selectedTags) {
      const ref = db.collection('users').doc(this.activeUserID).collection('recipes').doc(this.recipeID);
      var recipeTags = []
      for (let i = 0; i < selectedTags.length; i++) {
        const tagText = selectedTags[i];
        for (let j = 0; j < this.tags.length; j++) {
          const tag = this.tags[j];
          if(tagText.toLowerCase() == tag.text.toLowerCase()) {
            recipeTags.push(tag.value)
            break
          }
        }
      }
      ref.update({tags: recipeTags}).then(() => {
        this.draggableList = false
      })
    },
    loadImage(imageRef) {
      // Probeer eerst de medium versie (400x400) voor detail pagina
      const imageName = imageRef.name;
      const mediumName = imageName.replace(/(\.[^.]+)$/, '_400x400$1');
      const mediumPath = imageRef.parent.fullPath + '/' + mediumName;
      const storageRef = firebase.storage().ref();
      
      storageRef.child(mediumPath).getDownloadURL()
        .then( url => {
          this.imageURL = url
        })
        .catch( () => {
          // Als medium versie niet bestaat, gebruik origineel
          console.log('Medium versie niet gevonden, gebruik origineel');
          return imageRef.getDownloadURL();
        })
        .then( url => {
          if (url) {
            this.imageURL = url
          }
        })
        .catch( error => {
          console.log(error)
          this.imageURL = this.getDefaultImageName()
        })
    },
    getImageRef(imageName) {
      const imagePath = "images/recipes/" + imageName;
      const storageRef = firebase.storage().ref()
      return storageRef.child( imagePath );
    },
    getImageName(recipeName, activeUserID, recipeID) {
      const slug = this.convertToSlug(recipeName)
      return slug + "-" + activeUserID + "-" + recipeID;
    },
    getDefaultImageName:function() {
      return "default-image.jpeg"
    },
    convertToSlug: function(text)
    {
        return text
            .toLowerCase()
            .replace(/[^\w ]+/g,'')
            .replace(/ +/g,'-')
            ;
    },
    getIngredientText: function(item) {
      var eenheid = item.calculatedNumber > 1 && item.eenheid.meervoud != "" ? item.eenheid.meervoud : item.eenheid.naam;
      var naam = item.calculatedNumber > 1 && item.ingredient.meervoud != "" ? item.ingredient.meervoud : item.ingredient.naam;
      
      var txt = ""
      //check if eenheid geen 'stuk' is anders weglaten, 
      //later anders doen namelijk: hidden prop in eenheid definieren
      if(item.eenheid.id != "tMoR9K8P7BdmyvrbjWfP" ) {
        txt = item.calculatedNumber + " " + eenheid + " " + naam
      } else {
        txt = item.calculatedNumber + " " + naam
      }
      var bewerking = item.bewerking ? item.bewerking.naam : false
      return txt + (bewerking ? " - " + bewerking : "");
    },
    createIngredient: function() {
      this.selectedIngredient = {calculatedNumber:null, aantal: null, eenheid: {}, ingredient: {}, bewerking: {}}
      this.$bvModal.show("modalRecipeIngredient")
    },
    submitCreatedIngredient: function(ingredient) {
      this.recipeIngredients.push(ingredient)
      this.initRecipeIngredients(this.recipeIngredients)
      this.calculateNutrients()
      this.saveIngredients()
    },
    submitUpdatedIngredient: function(ingredient) {
      console.log("submitUpdatedIngredient")
      for (let i = 0; i < this.recipeIngredients.length; i++) {
        const ingr = this.recipeIngredients[i];
        if(ingr.id == ingredient.id) {
          this.recipeIngredients[i] = ingredient
          break;
        }
      }
      this.calculateNutrients()
      this.saveIngredients()
    },
    submitDeleteIngredient: function(ingredient) {
      let i = -1
      for (i = 0; i < this.recipeIngredients.length; i++) {
        const ingr = this.recipeIngredients[i];
        if(ingr.ingredient.id == ingredient.ingredient.id) {
          break;
        }
      }
      this.recipeIngredients.splice(i,1)
      this.selectedIngredient = EMPTY_INGREDIENT
      this.calculateNutrients()
      this.saveIngredients()
    },
    deleteRecipe: function() {
      db.collection('users').doc(this.activeUserID)
        .collection('recipes').doc(this.recipeID)
        .delete()
        .then(() => {
          this.$bvModal.hide("recipeModal")
          this.$router.push("/recipe-list")
        })
    },
    toggleListModus: function() {
      this.draggableList=!this.draggableList
    },
    updateIngredientsOrder: function(newOrder) {
      // Update de lokale ingrediënten array met de nieuwe volgorde
      this.recipeIngredients = newOrder;
    },
    calculateNutrients:function() {
      let kCalTotal = 0
      for (let i = 0; i < this.recipeIngredients.length; i++) {
        const ingredient = this.recipeIngredients[i];
        if(ingredient.kCal_pp) {
          kCalTotal += ingredient.kCal_pp
        }
      }
      this.kCalTotal = Math.round(kCalTotal)
    },
    /**
     * Stores the order of the ingredients
     * TODO: look here for validator: https://json-schema.org/implementations.html
     */
    saveIngredients: function(keepDraggable = false) {
      console.log("saveIngredients")
      // Maak een kopie van de ingrediënten zonder de 'selected' property
      const ingredientsToSave = this.recipeIngredients.map(ing => {
        const copy = {...ing}
        delete copy.selected
        return copy
      })
      
      const recipeDocRef = db.collection('users').doc(this.activeUserID).collection('recipes').doc(this.recipeID);
      recipeDocRef.update({ingredients: ingredientsToSave}).then( () => {
        // Behoud de draggable state zonder de volgorde te resetten
        this.draggableList = keepDraggable
        // Update het recipe object ook met de nieuwe volgorde
        this.recipe.ingredients = ingredientsToSave
      })
      .catch( error => {
        console.log("saveIngredients -> Error:")
        console.log(error)
      })
    },
    showIngredientModal: function(ingredient) {
      //duplicate object to be able to cancel changes
      this.selectedIngredient = Object.assign({}, ingredient)
      this.$bvModal.show("modalRecipeIngredient")
    },
    changeRecipeRatio: function(numberOfEaters) {
      this.numberOfEaters = numberOfEaters
      this.recipe.aantal_personen = this.numberOfPersons = numberOfEaters
      this.submitRecipe(this.recipe)
    },
    calcEaterChange: function(number) {
      if( number < 0 ) return;
      this.numberOfEaters = number  // Update numberOfEaters zodat de UI synchroon blijft
      this.recipe.eaterPersonRatio = this.eaterPersonRatio = number / this.numberOfPersons
      this.submitRecipe(this.recipe)
      for (let i = 0; i < this.recipeIngredients.length; i++) {
        const ingredient = this.recipeIngredients[i];
        ingredient.calculatedNumber = this.round(this.eaterPersonRatio * ingredient.aantal,1)
      }
      this.saveIngredients()
    },
    round: function(value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    },
    submitRecipeTimeout: function(recipe) {
      clearTimeout(this.cancelSubmitRecipeTimeout)
      this.cancelSubmitRecipeTimeout = setTimeout(this.submitRecipe, 1000, recipe)
    },
    submitRecipe: function(recipe) {
      console.log("submitRecipe")
      db.collection('users').doc(this.activeUserID)
        .collection('recipes').doc(this.recipeID)
        .update(recipe)
    },
    getIngredientsSnapshot: function() {
      const recipeRef = db.collection('users').doc(this.activeUserID)
      .collection('recipes').doc(this.recipeID);
      //this.unsubscribe = recipeRef.onSnapshot(snapshot => {
      recipeRef.get().then(snapshot => {
          const data = snapshot.data()
          if(data && data.ingredients) {
            this.initRecipeIngredients(data.ingredients)
          }
        })
    },
    initRecipeIngredients:function(ingredients) {
      this.recipeIngredients = []
      for (let i = 0; i < ingredients.length; i++) {
        const ingredient = ingredients[i];
        // Gebruik bestaande ID of genereer een nieuwe unieke ID
        if (!ingredient.id) {
          ingredient.id = Date.now().toString(36) + Math.random().toString(36).substr(2);
        }
        ingredient.selected = false;
        ingredient.calculatedNumber = this.round(this.eaterPersonRatio * ingredient.aantal,1)
        this.recipeIngredients.push(ingredient);
      }
      this.calculateNutrients()
    },
    setRecipeTags: function(recipeTags) {
      if(!recipeTags || recipeTags.length == 0) {
        this.validateTags = true
        return;
      }
      this.validateTags = false;
      this.selectedTags = []
      for (let i = 0; i < recipeTags.length; i++) {
        const tg = recipeTags[i];
        this.selectedTags.push(tg.name)
      }
      this.$nextTick(()=>{
        this.validateTags = true;
      })
    },
    unsubscribeIngredients: function() {
      if(this.unsubscribe) this.unsubscribe();
    },
    initQuantumData: function(recipe) {
      if(!recipe || !recipe.aantal_personen) {
        // Gebruik default waarden als recipe nog niet geladen is
        this.numberOfEaters = this.numberOfPersons = 4
        this.eaterPersonRatio = 1
        return;
      }
      
      if(!recipe.eaterPersonRatio) {
        this.numberOfEaters = this.numberOfPersons = recipe.aantal_personen
        this.eaterPersonRatio = 1
      } else {
        this.numberOfPersons = recipe.aantal_personen
        this.eaterPersonRatio = recipe.eaterPersonRatio
        this.numberOfEaters = Math.round(recipe.eaterPersonRatio * recipe.aantal_personen)
      }
    },
    sort() {
      this.list = this.list.sort((a, b) => a.order - b.order);
    },
  },
  mounted: function() {
    if(this.activeUserID === null) {
      this.$router.push("/home");
    }
    
    // Initialiseer met default waarden
    this.initQuantumData(this.recipe)
    
    //console.log(this.user, this.activeUserID, this.recipeID)
    if(this.activeUserID) {
      const userRef = db.collection('users').doc(this.activeUserID)
      const ref =  userRef.collection('recipes').doc(this.recipeID);
      ref.get().then((doc) => {
        this.recipe = doc.data();
        this.initQuantumData(this.recipe)
        this.getIngredientsSnapshot()
        this.setRecipeTags(this.recipe.tags)

        const imageName = this.recipe.image ? this.recipe.image : this.getDefaultImageName()
        this.loadImage(this.getImageRef(imageName))


        userRef.collection("shoppingLists").doc("active").get().then( shpLstDoc => {
            const data = shpLstDoc.data()
            this.shoppingListRecipes = (data && data.recipes) ? data.recipes : []
            this.shoppingList = (data && data.items) ? data.items : []
          })
      })
      .catch((error) => {
          console.error("Error retrieving recipe: ", error);
      });
    }

    
  },
};
</script>
<style>
.headerFade-enter-active {
  transition: opacity 1s;
}
.headerFade-enter  /* .headerFade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.button {
  margin-top: 35px;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.1;
  background: #55994B;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
.custom-file-input ~ .custom-file-label::after {
  content: 'Browsse';
}

</style>
